"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function scriptAlreadyLoaded(scriptUrl) {
    var exists = false;
    var scripts = document.getElementsByTagName('script');
    if (scripts && scripts.length > 0) {
        for (var scriptIndex in scripts) {
            var script = scripts[scriptIndex];
            if (script.src === scriptUrl) {
                exists = true;
            }
        }
    }
    return exists;
}
exports.scriptAlreadyLoaded = scriptAlreadyLoaded;
function injectScript(scriptUrl) {
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.onload = function () {
            resolve();
        };
        script.onerror = function (e) {
            reject('Unable to load ' + scriptUrl + 'script');
        };
        script.src = scriptUrl;
        document.getElementsByTagName('head')[0].appendChild(script);
    });
}
exports.injectScript = injectScript;
function appendChild(parentElementId, child) {
    var parentElement = document.getElementById(parentElementId);
    if (parentElement) {
        parentElement.appendChild(child);
    }
}
exports.appendChild = appendChild;
function appendToBody(child) {
    document.body.appendChild(child);
}
exports.appendToBody = appendToBody;
function addFirstChildToBody(child) {
    document.body.insertBefore(child, document.body.firstChild);
}
exports.addFirstChildToBody = addFirstChildToBody;
function removeChild(parentElementId, childId) {
    var parentElement = document.getElementById(parentElementId);
    if (parentElement) {
        var child = getChildElement(parentElementId, childId);
        if (child) {
            parentElement.removeChild(child);
        }
    }
}
exports.removeChild = removeChild;
function removeChildren(parentElementId) {
    var parentElement = document.getElementById(parentElementId);
    if (parentElement) {
        while (parentElement.firstChild) {
            parentElement.removeChild(parentElement.firstChild);
        }
    }
}
exports.removeChildren = removeChildren;
function removeFromBody(childId) {
    var child = getElementFromBody(childId);
    if (child) {
        removeChildren(childId);
        document.body.removeChild(child);
    }
}
exports.removeFromBody = removeFromBody;
function getElementFromBody(childId) {
    var result = undefined;
    for (var i = 0; i < document.body.children.length && !result; i++) {
        var child = document.body.children[i];
        if (child.id === childId) {
            result = child;
        }
    }
    return result;
}
exports.getElementFromBody = getElementFromBody;
function getChildElement(parentElementId, childId) {
    var parentElement = document.getElementById(parentElementId);
    var result = undefined;
    if (parentElement) {
        for (var i = 0; i < parentElement.children.length && !result; i++) {
            var child = parentElement.children[i];
            if (child.id === childId) {
                result = child;
            }
        }
    }
    return result;
}
exports.getChildElement = getChildElement;
function createElement(tag, attributes) {
    if (attributes === void 0) { attributes = {}; }
    var element = document.createElement(tag);
    for (var attribute in attributes) {
        element.setAttribute(attribute, attributes[attribute]);
    }
    return element;
}
exports.createElement = createElement;
function setElementAttribute(element, key, value) {
    if (element) {
        element.setAttribute(key, value);
    }
}
exports.setElementAttribute = setElementAttribute;
function deleteElementAttribute(element, key) {
    if (element) {
        element.removeAttribute(key);
    }
}
exports.deleteElementAttribute = deleteElementAttribute;
